var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.168 17.5C14.3101 17.5 17.668 14.1421 17.668 10C17.668 5.85786 14.3101 2.5 10.168 2.5C6.02583 2.5 2.66797 5.85786 2.66797 10C2.66797 14.1421 6.02583 17.5 10.168 17.5Z",
    fill: "url(#paint0_linear_4375_34283)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99053 11.0439L8.94968 11.0125L8.90329 10.9902L7.77829 10.4482L7.75013 10.4346L7.72049 10.4247L6.21007 9.91731L13.2408 7.16031L12.0116 13.3605L8.99053 11.0439ZM5.79872 9.76718C5.79889 9.76715 5.80049 9.7684 5.80302 9.77101C5.79982 9.7685 5.79855 9.7672 5.79872 9.76718ZM5.77897 10.0941C5.77801 10.095 5.77748 10.0954 5.77745 10.0954C5.77742 10.0953 5.7779 10.0949 5.77897 10.0941ZM13.5596 7.05473C13.5595 7.05485 13.5573 7.05496 13.5534 7.05468C13.5577 7.05447 13.5597 7.05461 13.5596 7.05473ZM12.0424 13.3721C12.0424 13.3722 12.0419 13.3722 12.0408 13.3721C12.0418 13.3721 12.0424 13.3721 12.0424 13.3721Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44727 13.4922C8.44727 13.4922 8.35645 13.4834 8.24512 13.1289C8.13379 12.7744 7.5625 10.8994 7.5625 10.8994L12.1064 8.01367C12.1064 8.01367 12.3701 7.85547 12.3584 8.01367C12.3584 8.01367 12.4053 8.04297 12.2646 8.17188C12.124 8.30371 8.69629 11.3857 8.69629 11.3857",
    fill: "#D2E4F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87012 12.3486L8.64844 13.4648C8.64844 13.4648 8.55176 13.5381 8.44922 13.4912L8.68359 11.4199",
    fill: "#B5CFE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4375_34283",
    x1: 10.168,
    y1: 2.5,
    x2: 10.168,
    y2: 17.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A6DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ecb66b32853dbad625f5304e18b93d9d.svg";
export { ForwardRef as ReactComponent };